var map = {
	"./BackgroundStripes.png": 136,
	"./Book.png": 42,
	"./BookAndEbook.png": 43,
	"./Complimentary Monday.png": 137,
	"./Complimentary Sunday.png": 138,
	"./Complimentary Tuesday.png": 139,
	"./CoverCircle (1).png": 140,
	"./CoverCircle.png": 141,
	"./Ebook.png": 44,
	"./Front Cover.png": 37,
	"./Logo with Plate-04.png": 45,
	"./Week 1 Friday.png": 142,
	"./Week 1 Monday.png": 143,
	"./Week 1 Saturday.png": 144,
	"./Week 1 Sunday Dessert.png": 145,
	"./Week 1 Thursday.png": 146,
	"./Week 1 Tuesday.png": 147,
	"./Week 1 Wednesday.png": 148,
	"./Week 2 Friday.png": 149,
	"./Week 2 Monday.png": 150,
	"./Week 2 Saturday.png": 151,
	"./Week 2 Sunday.png": 152,
	"./Week 2 Thursday.png": 153,
	"./Week 2 Tuesday.png": 154,
	"./Week 2 Wednesday.png": 155,
	"./Week 3 Friday.png": 156,
	"./Week 3 Monday.png": 157,
	"./Week 3 Saturday.png": 158,
	"./Week 3 Sunday Dessert.png": 159,
	"./Week 3 Sunday.png": 160,
	"./Week 3 Thursday.png": 161,
	"./Week 3 Tuesday.png": 162,
	"./Week 3 Wednesday.png": 163,
	"./Week 4 Friday.png": 164,
	"./Week 4 Monday.png": 165,
	"./Week 4 Saturday.png": 166,
	"./Week 4 Sunday.png": 167,
	"./Week 4 Thursday.png": 168,
	"./Week 4 Tuesday.png": 169,
	"./Week 4 Wednesday.png": 170,
	"./Week 5 Friday.png": 171,
	"./Week 5 Monday.png": 172,
	"./Week 5 Saturday.png": 173,
	"./Week 5 Sunday Dessert.png": 174,
	"./Week 5 Sunday.png": 175,
	"./Week 5 Thursday.png": 176,
	"./Week 5 Tuesday.png": 177,
	"./Week 5 Wednesday.png": 178,
	"./Week 6 Friday.png": 179,
	"./Week 6 Monday.png": 180,
	"./Week 6 Saturday.png": 181,
	"./Week 6 Sunday Dessert.png": 182,
	"./Week 6 Sunday.png": 183,
	"./Week 6 Thursday.png": 184,
	"./Week 6 Tuesday.png": 185,
	"./Week 6 Wednesday.png": 186,
	"./bs.png": 187,
	"./digest1.png": 188,
	"./digest1Jill.png": 189,
	"./digest1Mary.png": 190,
	"./digest1Orange.png": 191,
	"./digestBanner.png": 192,
	"./starburst.png": 24,
	"./starburstAvoBG.png": 193,
	"./starburstBrown.png": 194,
	"./starburstChar.png": 195,
	"./starburstDABG.png": 196,
	"./starburstGold.png": 197,
	"./starburstOrangeBG.png": 198,
	"./starburstWhiteLA.png": 199,
	"./sub.png": 200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;